var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7158 17.0175C21.6795 12.9748 25.0216 11.008 25.1744 10.9165C23.2817 8.15316 20.3481 7.77561 19.3171 7.74551C16.8532 7.48586 14.4631 9.22186 13.208 9.22186C11.9278 9.22186 9.99494 7.77059 7.91178 7.81324C5.23112 7.85463 2.72343 9.40875 1.34792 11.8221C-1.49048 16.7428 0.626392 23.9741 3.34599 27.9516C4.70626 29.9008 6.29597 32.0745 8.37652 31.998C10.4121 31.9152 11.1724 30.6998 13.6289 30.6998C16.0627 30.6998 16.7768 31.998 18.8986 31.9491C21.0834 31.9152 22.4587 29.9924 23.7715 28.0268C25.3436 25.7954 25.9748 23.5953 26 23.4824C25.9498 23.4648 21.7584 21.8618 21.7158 17.0175ZM17.7074 5.12897C18.8021 3.75798 19.5513 1.89279 19.3433 0C17.7586 0.0702426 15.777 1.09754 14.6358 2.43842C13.6261 3.62001 12.7242 5.5567 12.9572 7.37799C14.7374 7.51095 16.565 6.47863 17.7074 5.12897Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/appStore.d1e23bd55a14407d37d4a22f78689ace.svg";
export { ForwardRef as ReactComponent };